// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.banner-activity {
    margin-top: 5px;
    height: 50px;
    width: 250px;
    position: fixed;
    transform: translateX(-50%);
    left: 46%;
    top: 0;
  }
  
  .history-content 
{
  position: fixed;
  left: 0;
  top: 60px;
  width: 100vw;
  height: calc(100vh - 70px);
  padding-left: 15px;
  padding-right: 15px;
  box-sizing: border-box;
  overflow: hidden;
  font-size: 14px;
}

.history-filters
{
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  font-size: 15px;
  width: 100%;
}

.date-inputs {
  display: flex;
  flex-direction: column;
  margin-bottom: 5px;
}

.date-input {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
}

.date-input label {
  margin-bottom: 5px;
  font-size: 15px;
  width: 20%;
  height: 18px;
  font-weight: bold;
  display: flex;
  align-items: center;
}

.date-input input {
  font-size: 15px;
  height: 18px;
}

.resume-table-container {
  overflow-x: auto;
  overflow-y: auto;
  max-height: calc(100% - 63px); /* Adjust this value as needed */
}

.resume-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: auto;
}

.resume-table th,
.resume-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
  white-space: nowrap;
}

.resume-table th {
  background-color: #f2f2f2;
  font-weight: bold;
  position: sticky;
  top: 0;
  z-index: 1; /* Ensure the header stays above table rows */
}

.loading-spinner {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
}

.error-message {
  color: red;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
}

.map-overlay {
  position: fixed;
  top: 155px;
  left: 14px;
  width: calc(100% - 28px);
  height: calc(100% - 165px);
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.close-map-button {
  position: absolute;
  top: 5px;
  right: 5px;
  padding: 5px 5px;
  background: #fff;
  border: none;
  border-radius:5px;
  cursor: pointer;
  z-index: 1001;
}

.vehicle-select {
  display: flex;
  justify-content: space-between;
   /* Asegúrate de que no supere el ancho de la ventana */
}

.vehicle-filter {
  flex: 1 1; /* Ocupa el espacio restante */
  margin-right: 10px; /* Espacio entre el filtro y el select */
  font-size: 15px;
  width:30vw;
}

.vehicle-select select {
  flex-grow: 1;
  font-size: 15px;
  margin-right: 10px;
  padding: 1px;
  width:30vw;
}

.vehicle-select button {
  padding: 1px;
  font-size: 15px;
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/components/Activity.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,2BAA2B;IAC3B,SAAS;IACT,MAAM;EACR;;EAEA;;EAEA,eAAe;EACf,OAAO;EACP,SAAS;EACT,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B,EAAE,gCAAgC;AACjE;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,MAAM;EACN,UAAU,EAAE,6CAA6C;AAC3D;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,UAAU;EACV,wBAAwB;EACxB,0BAA0B;EAC1B,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;GAC7B,sDAAsD;AACzD;;AAEA;EACE,SAAO,EAAE,8BAA8B;EACvC,kBAAkB,EAAE,wCAAwC;EAC5D,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB","sourcesContent":[".banner-activity {\n    margin-top: 5px;\n    height: 50px;\n    width: 250px;\n    position: fixed;\n    transform: translateX(-50%);\n    left: 46%;\n    top: 0;\n  }\n  \n  .history-content \n{\n  position: fixed;\n  left: 0;\n  top: 60px;\n  width: 100vw;\n  height: calc(100vh - 70px);\n  padding-left: 15px;\n  padding-right: 15px;\n  box-sizing: border-box;\n  overflow: hidden;\n  font-size: 14px;\n}\n\n.history-filters\n{\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 10px;\n  font-size: 15px;\n  width: 100%;\n}\n\n.date-inputs {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 5px;\n}\n\n.date-input {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 5px;\n}\n\n.date-input label {\n  margin-bottom: 5px;\n  font-size: 15px;\n  width: 20%;\n  height: 18px;\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n}\n\n.date-input input {\n  font-size: 15px;\n  height: 18px;\n}\n\n.resume-table-container {\n  overflow-x: auto;\n  overflow-y: auto;\n  max-height: calc(100% - 63px); /* Adjust this value as needed */\n}\n\n.resume-table {\n  width: 100%;\n  border-collapse: collapse;\n  table-layout: auto;\n}\n\n.resume-table th,\n.resume-table td {\n  border: 1px solid #ddd;\n  padding: 8px;\n  text-align: left;\n  white-space: nowrap;\n}\n\n.resume-table th {\n  background-color: #f2f2f2;\n  font-weight: bold;\n  position: sticky;\n  top: 0;\n  z-index: 1; /* Ensure the header stays above table rows */\n}\n\n.loading-spinner {\n  text-align: center;\n  font-size: 18px;\n  font-weight: bold;\n}\n\n.error-message {\n  color: red;\n  text-align: center;\n  font-size: 16px;\n  font-weight: bold;\n}\n\n.map-overlay {\n  position: fixed;\n  top: 155px;\n  left: 14px;\n  width: calc(100% - 28px);\n  height: calc(100% - 165px);\n  background: rgba(0, 0, 0, 0.8);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.close-map-button {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  padding: 5px 5px;\n  background: #fff;\n  border: none;\n  border-radius:5px;\n  cursor: pointer;\n  z-index: 1001;\n}\n\n.vehicle-select {\n  display: flex;\n  justify-content: space-between;\n   /* Asegúrate de que no supere el ancho de la ventana */\n}\n\n.vehicle-filter {\n  flex: 1; /* Ocupa el espacio restante */\n  margin-right: 10px; /* Espacio entre el filtro y el select */\n  font-size: 15px;\n  width:30vw;\n}\n\n.vehicle-select select {\n  flex-grow: 1;\n  font-size: 15px;\n  margin-right: 10px;\n  padding: 1px;\n  width:30vw;\n}\n\n.vehicle-select button {\n  padding: 1px;\n  font-size: 15px;\n  font-weight: bold;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
